<template>
  <div class="p-1">
    <p
      class="d-flex justify-content-left align-items-center text-info text-small px-1 cursor-pointer"
      style="gap: 10px; border-bottom: 1px solid #dae1e7; padding-bottom: 14px"
      @click="$router.push('/settings')"
    >
      <feather-icon icon="ArrowLeftIcon" size="15" class="align-middle" />
      <span>Back to Settings</span>
    </p>
    <p class="font-weight-bold my-1" style="font-size: 16px">USER MANAGEMENT</p>
    <div
      class="d-flex justify-content-between align-items-center font-weight-bold px-2"
    >
      <div
        v-for="item in menuList"
        :key="item.id"
        :class="{ 'active-menu-item': activeTab === item.id }"
        class="cursor-pointer"
        @click="handleClick(item)"
      >
        {{ item.name ?  item.name  : ""}}
      </div>
    </div>

    <div class="mt-1 pt-1" style="border-top: 1px solid #dae1e7">
      <RoleSelect
        v-model="filterRoleId"
        :options="optionsRole"
        :isChangeStyle="true"
      />

      <div
        class="mt-1 pt-1"
        style="
          border-top: 1px solid #dae1e7;
          height: calc(100vh - 370px);
          overflow-y: auto;
        "
      >
        <div
          style="
            background: #eff6ff;
            border: 1px solid #bedbff;
            border-radius: 4px;
            padding: 6px 10px;
            margin-bottom: 5px;
          "
          v-for="admin in adminList"
          :key="admin.userId"
          class="d-flex justify-content-between align-items-center"
        >
          <div class="d-flex align-items-center">
            <b-avatar
              variant="white"
              style="
                background: white;
                width: 28px;
                height: 28px;
                margin-right: 10px;
              "
            >
              <feather-icon
                icon="UsersIcon"
                size="18"
                class="align-middle text-primary"
              />
            </b-avatar>
            <div class="d-flex flex-column">
              <small class="m-0 font-weight-bold" style="font-size: 13px">{{
                `${admin.firstName ? admin.firstName + ' ' : ''}${admin.lastName ? admin.lastName : ''}`
              }}</small>
              <small v-if="admin.roles && admin.roles.length > 0 && admin.roles[0] &&  admin.roles[0].name" class="m-0">{{
                admin.roles[0].name
              }}</small>
            </div>
          </div>
          <small
            class="text-small"
            style="padding: 1px 10px; border-radius: 10px"
            :style="{ background: admin.status === 'inactive' ? '#e5e7eb' : '#dcfce7' }"
            >{{ admin.status }}</small
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BCard,
  BCol,
  BIcon,
  BRow,
  BButton,
  BFormInput,
  BTable,
  BAvatar,
} from "bootstrap-vue";
import AdminList from "../roles-permissions/user-list/AdminList.vue";
import useToastHandler from "@/services/toastHandler";
import { mapActions, mapState } from "vuex";
import { formatTime } from "@/helpers/utils";
import RoleSelect from "../roles-permissions/user-list/RoleSelect.vue";

export default {
  components: {
    BIcon,
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    AdminList,
    BTable,
    RoleSelect,
    BAvatar,
  },
  data() {
    return {
      menuList: [
        { id: 1, name: "Users" },
        // { id: 2, name: "Roles" },
        { id: 3, name: "Settings" },
        { id: 4, name: "Audit" },
      ],
      activeTab: 1,
      adminList: [],
      filterRoleId: "all",
      optionsRole: [
        {
          name: "All Roles",
          value: "all",
        },
      ],
    };
  },
  computed: {},
  watch: {
    filterRoleId() {
      this.fetchAdminList();
    },
  },
  async mounted() {
    this.$store.commit("app/UPDATE_ACTIVE_MENU_SETTING", 1);
    await this.fetchAdminList();

    const res = await this.getRoleList({
      page: 1,
      limit: 100,
    });
    this.optionsRole = [
      {
        name: "All Roles",
        value: "all",
      },
      ...res.data.map((item) => ({
        name: item.name,
        value: item.roleId,
      })),
    ];
  },
  methods: {
    ...mapActions({
      getAdminList: "user/admin/getAdminList",
      getRoleList: "user/admin/getRoleList",
    }),
    async fetchAdminList() {
      const data = await this.getAdminList({
        isAdminUser: 1,
        page: 1,
        limit: 100,
        ...(this.filterRoleId !== "all" && { roleId: this.filterRoleId }),
      });
      this.adminList = data;
    },
    handleClick(item) {
      this.activeTab = item.id;
      this.$store.commit("app/UPDATE_ACTIVE_MENU_SETTING", item.id);
    },
  },
  setup() {
    const { showToastError, showToastSuccess } = useToastHandler();

    return {
      showToastError,
      showToastSuccess,

      formatTime,
    };
  },
};
</script>

<style scoped>
.active-menu-item {
  border-bottom: 2px blue solid;
  color: blue; /* Thêm màu để dễ nhận biết */
}
</style>
